"use client";

import createIcon from './util/createIcon';
export default createIcon('M13.92 11H18V13H13V15H18V17H13V21H11V17H6V15H11V13H6V11H10.08L5 3H7.37L12 10.29L16.63 3H19L13.92 11Z', 'CurrencyJpy');